import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.4.6_@opentelemetry+api@1.9.0_react-dom@19.1.1_react@19.1.1__react@19.1.1_sass@1.77.4/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.4.6_@opentelemetry+api@1.9.0_react-dom@19.1.1_react@19.1.1__react@19.1.1_sass@1.77.4/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/(frontend)/[...slug]/page.client.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/(frontend)/components/jsonld.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/blocks/AboutBlock/Component.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/blocks/AboutBlock2/Component.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/blocks/AboutBlock3/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ArchiveBlockClient"] */ "/app/src/blocks/ArchiveBlock/ClientComponent.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/blocks/CommentBlock/Component.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/blocks/CTABlocks/Component.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/blocks/FeatureBlocks/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/blocks/FeatureSection/ClientWrapper.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/blocks/Form/Component.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/blocks/Form/Component2.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/blocks/FormBlock4/Component.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/blocks/GalleryBlock/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/blocks/hero-parallax/ClientWrapper.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/blocks/hero-parallax/Component.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/blocks/Heroblock2/HeroBlock2.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/blocks/Heroblock4/component.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/blocks/leadgenform/Component.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/blocks/PratnerBlocks/Component.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/blocks/ServicesBlock/Component.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/blocks/TableOfContentBlock/TableOfContentBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/blocks/Team1Block/ClientWrapper.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/blocks/Team1Block/Component.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["TestimonialCard"] */ "/app/src/blocks/TestoMonialBlock/testomonial-card.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/blocks/TestoMonialBlock/testomonialBlock2.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/blocks/TestoMonialBlock/TestomonialBlock3.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/blocks/videoblock/Component.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/blocks/videoblock2/Component.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/LivePreviewListener/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ImageMedia"] */ "/app/src/components/Media/ImageMedia/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VideoMedia"] */ "/app/src/components/Media/VideoMedia/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/ui/accordion.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/ui/carousel.tsx");
